import estilosLayoutBoletos from './layout-boletos-estilos';
import { renderizarLayoutBoletos, renderizarSeparadorBoletos } from './layout-boletos-template';

const obterEstruturaBody = html => {
  const bodyTag = html.match(/<body[^>]*>/i);
  const bodyEnd = html.toLowerCase().lastIndexOf('</body>');

  if (!bodyTag || bodyEnd === -1) {
    return null;
  }

  const bodyStart = bodyTag.index + bodyTag[0].length;

  return {
    inicio: html.slice(0, bodyStart),
    conteudo: html.slice(bodyStart, bodyEnd),
    fim: html.slice(bodyEnd)
  };
};

export const aplicarLayoutBoletos = (html, tabelaErros = '', quantidadeSucessos = 0) => {
  const estruturaBody = obterEstruturaBody(html);
  const separador =
    tabelaErros.trim() && html.trim() ? renderizarSeparadorBoletos(quantidadeSucessos) : '';
  const conteudoBoletos = html.trim() ? `<div class="boletos-content">${html}</div>` : '';

  if (!estruturaBody) {
    return renderizarLayoutBoletos({
      estilos: estilosLayoutBoletos,
      tabelaErros,
      separador,
      conteudo: conteudoBoletos
    });
  }

  const conteudoBody = `<div class="boletos-content">${estruturaBody.conteudo}</div>`;
  const layout = renderizarLayoutBoletos({
    estilos: estilosLayoutBoletos,
    tabelaErros,
    separador,
    conteudo: conteudoBody
  });

  return `${estruturaBody.inicio}${layout}${estruturaBody.fim}`;
};

export default aplicarLayoutBoletos;
